/* eslint-disable no-unused-vars */
var json_variable = {
	"information": {
		"videourl": [
			"https://d1dejaj6dcqv24.cloudfront.net/presentations/rsa2010/video/enhancing-ipsids-with-vm-data.mp4",
			"https://d1dejaj6dcqv24.cloudfront.net/presentations/rsa2010/video/enhancing-ipsids-with-vm-data.webm",
			"https://d1dejaj6dcqv24.cloudfront.net/presentations/rsa2010/video/enhancing-ipsids-with-vm-data.ogg"
		],
		"slideurl": "https://d1dejaj6dcqv24.cloudfront.net/presentations/enhancing-ipsids-with-vm-data/",
		"title": "Presentation Title",
		"date": "10-1-2012",
		"time": "8:00 AM",
		"offset": 0
	},
	"presenters": [],
	"slides": [{
		"time": "00:00:00",
		"title": "Introduction",
		"url": "Slide1.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:00:15",
		"title": "Chapter Title",
		"url": "Slide2.jpg",
		"chapter": 0,
		"notes": ""
	}, {
		"time": "00:01:04",
		"title": "The Issues",
		"url": "Slide3.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:02:12",
		"title": "Solution Strategy",
		"url": "slides/Slide4.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:02:14",
		"title": "Chapter Title",
		"url": "Slide5.jpg",
		"chapter": 0,
		"notes": ""
	}, {
		"time": "00:02:20",
		"title": "Chapter Title",
		"url": "Slide6.jpg",
		"chapter": 0,
		"notes": ""
	}, {
		"time": "00:02:31",
		"title": "IDS Events without Context ",
		"url": "Slide7.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:02:54",
		"title": "Contextual Data Reduces Event Investigation",
		"url": "Slide8.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:03:27",
		"title": "Methods of Adding Context",
		"url": "Slide9.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:03:45",
		"title": "Chapter Title",
		"url": "Slide10.jpg",
		"chapter": 0,
		"notes": ""
	}, {
		"time": "00:05:05",
		"title": "Passive Detection & Identification",
		"url": "Slide11.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:06:02",
		"title": "Active Scanning",
		"url": "Slide12.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:06:36",
		"title": "Passive Data's Impact",
		"url": "Slide13.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:06:52",
		"title": "Chapter Title",
		"url": "Slide14.jpg",
		"chapter": 0,
		"notes": ""
	}, {
		"time": "00:07:11",
		"title": "Why Add Qualys Data?",
		"url": "Slide15.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:08:04",
		"title": "Example of Sourcefire Event Impact Analysis",
		"url": "Slide16.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:08:27",
		"title": "Qualys Data Import",
		"url": "Slide17.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:08:52",
		"title": "Chapter Title",
		"url": "Slide18.jpg",
		"chapter": 0,
		"notes": ""
	}, {
		"time": "00:09:25",
		"title": "Chapter Title",
		"url": "Slide19.jpg",
		"chapter": 0,
		"notes": ""
	}, {
		"time": "00:09:35",
		"title": "Detail on Vulnerability",
		"url": "Slide20.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:09:50",
		"title": "Impact Assessment After Qualys Data Added",
		"url": "Slide21.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:10:01",
		"title": "Net Results",
		"url": "Slide22.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:10:26",
		"title": "Notes About Current Implementation",
		"url": "Slide23.jpg",
		"chapter": 1,
		"notes": ""
	}, {
		"time": "00:11:15",
		"title": "Next Steps",
		"url": "Slide24.jpg",
		"chapter": 1,
		"notes": ""
	}]
};
/* eslint-enable no-unused-vars */
